/**
 * Action types for etcd functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of etcd.
 */

// Get etcd constants
export const ETCD_REQUEST_GET = 'ETCD_REQUEST_GET';
export const ETCD_RESPONSE_GET_SUCCESS = 'ETCD_RESPONSE_GET_SUCCESS';
export const ETCD_RESPONSE_GET_FAIL = 'ETCD_RESPONSE_GET_FAIL'
